<!-- <div class="feedback-comment-container"> -->
    <!-- <h6 class="feedback-length">{{control.value.length}}/255</h6> -->
    <textarea name="" id="" cols="30" rows="10" class="feedback-comment" [formControl]="control"
    placeholder="Enter a description" [value]="'feedbackComment.value'" [ngClass]="{'error' : error}" >
</textarea>
<!-- </div> -->